import React from "react";
import "./styles/AssessmentSummary.scss";
import { Row, Col, Card, Select } from "antd";
import AssessmentAISummary from "./Components/AISummaryView";
import useAIAssessmentWrapper from "./hooks/useAIAssessmentWrapper";
import AssessmentAISummaryHandler from "./Components/AssessmentAISummaryHandler";


const AssessmentAISummaryWrapper: React.FC<any> = () => {
  const {
    data,
    errors,
    isLoading,
    selectedAssessment,
    handleOnChange,
  } = useAIAssessmentWrapper();
  

  return (
    <AssessmentAISummaryHandler
      data={data}
      errors={errors}
      isLoading={isLoading}
    >
      <div className="assessment-summary-container">
        <Card className="controls-card">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Select
                className="segments-select"
                size="middle"
                placeholder="Select Assessment"
                onChange={(value, option) => handleOnChange(value, option)}
                value={selectedAssessment?.value}
              >
                {data?.map((item: any) => (
                  <Select.Option key={item?.value} value={item?.value}>
                    {item.key.replace("-", " ")}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
        </Card>
        <AssessmentAISummary selectedAssessment={selectedAssessment} />
      </div>
    </AssessmentAISummaryHandler>
  );
};

export default AssessmentAISummaryWrapper;
